/**
 * Setzt die Sidebar (Selector) Sticky.
 * Dazu wird das Modul BASIC__library__sticky-sidebar genutzt
 *
 * @param selector - Selektor der sidebar
 * @param options - Object mit Einstellungen; Mögliche Konfigurationen siehe:
 * https://abouolia.github.io/sticky-sidebar/
 */
function nc_initStickySidebar(selector, options) {
    var moduleLogger = LoggerManager.get('sidebar_sticky-sidebar').setPrefix('Selektor: ' + selector);
    moduleLogger.trace('INIT START');

    $(window).load(function () {
        $(selector).stickySidebar(options);
    });

    moduleLogger.info('INIT ENDE');
}